module.exports = __webpack_public_path__ + "assets/img/logo-NB-b.cee5c615.svg";